import request from "@/utils/request"

// 提交
export function addSysClientInfo(obj) {
  return request({
    url: '/sysClientInfo',
    method: 'post',
    data: obj
  })
}

//联系我们
export function sysCompanyInfo(query) {
  return request({
    url: '/sysCompanyInfo/page',
    method: 'get',
    params: query
  })
}
// 首页
export function sysHomeConfig(query) {
  return request({
    url: '/sysHomeConfig/page',
    method: 'get',
    params: query
  })
}

// 维护
export function sysMaintenance(query) {
	return request({
		url: '/sysMaintenance/page',
		method: 'get',
		params: query,
	});
}

// 产品
export function getsysProduct(query) {
	return request({
		url: '/sysProduct/page',
		method: 'get',
		params: query,
	});
}
// 获取产品详情
export function getProductDetails(obj) {
	return request({
		url: '/sysProduct/details',
		method: 'get',
		params: obj,
	});
}
// 产品分类
export function getProductCategory(query) {
	return request({
		url: '/sysProductCategory/page',
		method: 'get',
		params: query,
	});
}
export function downBlobFile(key) {
	return request({
		url: key,
		method: 'get',
		responseType: 'blob',
	});
}